/** Fields keep their own keys, and an open dialog or menu owns the keyboard. */
const FOCUSED_CONTROL_TARGETS =
  'input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"]'
const OPEN_OVERLAYS = '[role="dialog"], [role="alertdialog"]'

/**
 * True when a key belongs to a field, an open dialog or a menu, so page-wide keys (scans,
 * shortcuts) leave it alone.
 */
export function isKeyForFocusedControl(event: KeyboardEvent): boolean {
  const { target } = event

  return (
    (target instanceof Element && target.closest(FOCUSED_CONTROL_TARGETS) !== null) ||
    document.querySelector(OPEN_OVERLAYS) !== null
  )
}
